export const DEFAULT_MEMBERS_COUNT = 10

export const MAX_MEMBERS_COUNT = 20
